import React from 'react';
import { ShieldAlert, ArrowLeft } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { useNavigate } from 'react-router-dom';

export default function SinPermiso({ moduleName }) {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-[60vh]" data-testid="sin-permiso-screen">
      <Card className="max-w-md w-full border-destructive/30">
        <CardContent className="flex flex-col items-center text-center py-10 px-6">
          <div className="w-16 h-16 rounded-full bg-destructive/10 flex items-center justify-center mb-4">
            <ShieldAlert className="w-8 h-8 text-destructive" />
          </div>
          <h2 className="text-xl font-bold mb-2" style={{ fontFamily: 'Space Grotesk' }}>
            Sin permiso
          </h2>
          <p className="text-sm text-muted-foreground mb-1">
            No tienes acceso a este módulo
            {moduleName ? ` (${moduleName})` : ''}.
          </p>
          <p className="text-xs text-muted-foreground mb-6">
            Contacta al super administrador para solicitar acceso.
          </p>
          <Button
            onClick={() => navigate('/')}
            variant="outline"
            data-testid="sin-permiso-volver"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Volver al Dashboard
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
